import OverlayBase from 'stimulus/overlay_base';

const CLOSING_CLASS = 'ui-dialog-overlay--closing';

export default class extends OverlayBase {
  static targets = ['dialog'];

  get panel() {
    return this.hasDialogTarget ? this.dialogTarget : null;
  }

  get triggerSelector() {
    return `[data-dialog-trigger="${this.element.id}"]`;
  }

  open() {
    this.element.classList.remove(CLOSING_CLASS);
    super.open();
  }

  confirm() {
    this.dispatch('confirm');
    this.requestClose();
  }

  requestClose() {
    if (this.element.hidden) return;

    this.element.classList.add(CLOSING_CLASS);
  }

  dismiss() {
    this.requestClose();
  }

  animationEnd(event) {
    if (event.target !== this.element) return;
    if (!this.element.classList.contains(CLOSING_CLASS)) return;

    this.element.classList.remove(CLOSING_CLASS);
    this.finishClose();
  }
}
